
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			}, "route-profile");
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/profile/index.js
// module id = gNuw
// module chunks = 11